import EmptyState from "../../components/app/EmptyState";
import { useT } from "../../lib/i18n";

export function ModulePlaceholder({ titleKey, phase, testid }) {
  const t = useT();
  return (
    <EmptyState
      title={t(titleKey)}
      description={`${t(titleKey)} — coming in ${phase}.`}
      phase={phase}
      testid={testid}
    />
  );
}

export const Campaigns = () => <ModulePlaceholder titleKey="nav.campaigns" phase="Phase 3" testid="page-campaigns" />;
export const Assets = () => <ModulePlaceholder titleKey="nav.assets" phase="Phase 3" testid="page-assets" />;
export const Content = () => <ModulePlaceholder titleKey="nav.content" phase="Phase 4" testid="page-content" />;
